export { default } from "./usePollingForPollResults";
